<template>
  <div style="padding: 10px">
      <el-row style="margin-bottom: 20px;" >
        <el-col :span="8">
          <el-select v-model="formData.out_store_id" class="form-item" placeholder="调拨出库仓库" clearable @change="clearPreData()">
            <el-option v-for="item in myStoreList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <el-select v-model="formData.in_store_id" class="form-item" placeholder="到达仓库" clearable>
            <el-option v-for="item in allStoreList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <el-button @click="addMaterial(6)">添加物料行</el-button>
        </el-col>
      </el-row>

      <el-row class="box">
        <el-col :span="10">物料名称</el-col>
        <el-col :span="6">库位-批次</el-col>
        <el-col :span="3">当前库存</el-col>
        <el-col :span="4">出库数量</el-col>
        <el-col :span="1"></el-col>
      </el-row>

      <div style="height:290px;overflow-y: auto;overflow-x: hidden">
        <el-row v-for="item in formData.item_list" :key="item.id" class="row" :gutter="15" >
          <el-col :span="10">
            <el-select
                v-model="item.material_id"
                placeholder="选择物料"
                remote
                :remote-method="getMaterialAll"
                @focus="selectFocus(item.nanoid)"
                @change="onMaterialChange(item)"
                :loading="remoteLoading"
                style="width: 100%" clearable filterable>
              <el-option v-for="item in item.materialList" :key="item.id" :label="'【'+item.code+'】'+item.name" :value="item.id"></el-option>
            </el-select>
<!--            <el-select v-model="item.material_id" placeholder="选择物料" style="width: 100%" clearable filterable @change="onMaterialChange(item)">-->
<!--              <el-option v-for="material in materialAll" :key="material.id" :label="material.name" :value="material.id"></el-option>-->
<!--            </el-select>-->
          </el-col>
          <el-col :span="6" >
            <el-select v-model="item.material_stock_id" placeholder="选择库位-批次" style="width: 100%" clearable filterable @change="onStockItemChange(item)">
              <el-option v-for="stockItem in item.stock_list" :key="stockItem.id" :label="getStockItemLabel(stockItem)" :value="stockItem.id"></el-option>
            </el-select>
          </el-col>
          <el-col :span="3" >
            <el-input v-model="item.stock" placeholder="当前库存" readonly style="width: 100%"></el-input>
          </el-col>
          <el-col :span="4">
            <el-input v-model="item.cnt" placeholder="出库数量" style="width: 100%"></el-input>
          </el-col>
          <el-col :span="1">
            <div class="close" @click="removeOneMaterial(item.nanoid)">
              <el-icon>
                <ElIconClose></ElIconClose>
              </el-icon>
            </div>
          </el-col>
        </el-row>
      </div>

      <el-row style="margin-top: 15px">
        <el-col :span="24">
          <el-input type="textarea" class="quote-remark" v-model="formData.remark" placeholder="备注" style="width: 100%" :autosize="true"></el-input>
        </el-col>
      </el-row>

      <el-form-item>
        <el-button type="primary" style="width: 600px;;margin-top: 20px" @click="createTransfer" :loading="loading">提交调拨单</el-button>
      </el-form-item>

  </div>
</template>

<script>
import {nanoid} from 'nanoid'
export default {
  name: "CreateTransfer",
  inject: ['$fn'],
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      formData: {
        out_store_id: '',
        in_store_id: '',
        remark:'',
        item_list: []
      },
      allStoreList:[],
      myStoreList:[],
      // materialAll:[],
      loading: false,
      remoteLoading: false,
      focusNanoid: '',
    }
  },
  computed: {
  },
  created() {
    this.getStoreList()
    this.getMyStoreList()
    // this.getMaterialAll()
    this.addMaterial(6)
  },
  methods: {
    async getStoreList(){
      this.allStoreList = await this.$http('wmsDsService.getAllStore');
    },
    async getMyStoreList(){
      this.myStoreList = await this.$http('wmsDsService.getAccessibleStore');
    },

    selectFocus(nanoid) {
      this.focusNanoid = nanoid;
    },
    async getMaterialAll(query) {
      this.remoteLoading = true
      this.$http('wmsMaterialService.getRemoteDs', {value: query}, false).then(data => {
        this.remoteLoading = false
        let item = this.formData.item_list.find(item => item.nanoid === this.focusNanoid);
        item.materialList = data
      }, errMsg => {
        this.remoteLoading = false
        this.$message.error(errMsg);
      })
    },

    async onMaterialChange(item){
      item.stock = 0;
      item.cnt = 0;

      if(this.formData.out_store_id == ''){
        return this.$message.error("未选择出库源头仓库");
      }

      if(item.material_id == ''){
        return;
      }

      var params = {store_id:this.formData.out_store_id, material_id:item.material_id}
      item.stock_list = await this.$http('wmsMaterialStockService.getStockList', params);

      //默认选中第一行
      if(item.stock_list.length > 0){
        var stockItem = item.stock_list[0]
        item.material_stock_id = stockItem.id
        item.stock = stockItem.cnt
      }
    },
    onStockItemChange(item){
      item.stock = 0;
      if(item.stock_list){
        for(var i=0;i<item.stock_list.length;i++){
          var stockItem = item.stock_list[i]
          if(item.material_stock_id == stockItem.id){
            item.stock = stockItem.cnt
            break;
          }
        }
      }
    },
    getItemLabel(item){
      return item.name + '(' + item.code + ')';
    },
    getStockItemLabel(item){
      var label = item.location_code;
      if(item.batch_no){
        label = label + ' ' + item.batch_no
      }

      label = label + ' (' + item.cnt + ')';
      return label;
    },
    reset() {
      this.clearPreData()
      this.$refs.commitMessage.clear()
    },
    clearPreData() {
      //清空表单数据
      this.formData.item_list = []
      this.addMaterial(6);
    },
    async createTransfer() {

      if(this.formData.out_store_id == ''){
        return this.$message.error("未选择出库仓库");
      }

      if(this.formData.in_store_id == ''){
        return this.$message.error("未选择到达仓库");
      }

      var a = 0;
      for (let i = 0; i < this.formData.item_list.length; i++) {
        let obj = this.formData.item_list[i]
        if (obj.material_id) {

            if (!obj.cnt) {
              return this.$message.error(`第${i + 1}行数量不能为空`);
            }

            if (obj.cnt > obj.stock) {
              return this.$message.error(`第${i + 1}行退料数量不能超过库存数量`);
            }

            a++;
            obj.has_data = true;
        }
      }

      if (a == 0) {
        return this.$message.error("出库数据不能为空");
      }

      await this.$http('wmsTransferService.create', this.formData);

      this.$message.success("提交成功");
      this.$fn.closeWindow();
      this.$fn.search();
      this.clearPreData();
    },
    addMaterial(cnt) {
      for (let i = 0; i < cnt; i++) {
        this.formData.item_list.push({
          nanoid: nanoid(),
          productDetails: {},
          materialList: [],
        })
      }
    },
    removeOneMaterial(nanoid) {
      let index = this.formData.item_list.findIndex(item => item.nanoid === nanoid);
      this.formData.item_list.splice(index, 1);
    }
  }
}
</script>

<style scoped>
.form-item {
  width: 240px;
}

.product-head {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  margin-top: 15px;
}

.product-head span {
  margin-left: 50px;
}

.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.row {
  margin-top: 15px;
  padding: 0;
}

.row .tip {
  color: goldenrod;
  text-align: center;
  font-size: 14px;
}

.w-percent-90 {
  width: 90%;
}

.w100 {
  width: 120px;
}

.w95 {
  width: 95px;
}

.tax-amount {
  color: red;
  font-size: 18px;
}

.tax-amount span {
  margin-left: 15px;
}

.quote-remark {
  width: 100%;
  padding-right: 15px;
}

.close {
  position: absolute;
  top: 5px;
  right: 18px;
  font-size: 18px;
  cursor: pointer;
}
</style>